var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCondenseIconDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 12,
    viewBox: "0 0 19 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#FFF",
    strokeOpacity: 0.5,
    strokeWidth: 3,
    d: "M896 36L904 44 912 36",
    transform: "matrix(1 0 0 -1 -894 47)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCondenseIconDesktop);
export default __webpack_public_path__ + "static/media/condense-icon-desktop.c6cbf0c0485a8d167cd620c476b30a9e.svg";
export { ForwardRef as ReactComponent };